import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import NavBar from "./components/NavBar";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Segmentation from "./pages/Segmentation";
import CustomerMap from "./pages/CustomerMap";
import YearlyOverview from "./pages/YearlyOverview";
import Reports from "./pages/Reports";
import Callback from "./pages/Callback";
import CustomerDetail from "./pages/CustomerDetail";
import Silent from "./pages/Silent";
import Actions from "./pages/Actions";
import VAGovt from "./pages/VAGovt";
import HospitalUnits from "./pages/HospitalUnits";

function RequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  if (auth.isLoading) return <FullPageMessage>Loading…</FullPageMessage>;
  if (auth.error) return <FullPageMessage>Auth error: {auth.error.message}</FullPageMessage>;
  if (!auth.isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

function FullPageMessage({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center text-ink-500">
      {children}
    </div>
  );
}

export default function App() {
  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AuthedShell />
            </RequireAuth>
          }
        />
      </Routes>
    </div>
  );
}

function AuthedShell() {
  return (
    <>
      <NavBar />
      <main className="mx-auto max-w-page px-6 py-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/segmentation" element={<Segmentation />} />
          <Route path="/map" element={<CustomerMap />} />
          <Route path="/yearly" element={<YearlyOverview />} />
          <Route path="/customers/:id" element={<CustomerDetail />} />
          <Route path="/silent" element={<Silent />} />
          <Route path="/actions" element={<Actions />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/va-govt" element={<VAGovt />} />
          <Route path="/hospital-units" element={<HospitalUnits />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}
